import { httpPost, httpUpload, httpPostDownload, httpPostJson,httpPostDataDownload } from '@/utils/request';
interface leadAnalysisParams {
    start_time: string,
    end_time: string,
    date_compare: boolean, //是否比对（仅比对不同的时间跨度
    contrast_end_time: string, //待对比的结束日期
    contrast_start_time: string, //待对比的开始日期
    date_type?: string, //date, week, month, quarter, year
    fields?: string, //需合计的字段，逗号分隔多个
    group_by: string, //需聚合的字段(时间维度除外)
    need_sum?: boolean, //是否返回合计
    // sum_only?: boolean, //是否只合计当前分页数据
    order?: string, //asc 升序; desc 降序
    org_level?: string, //过滤部门，逗号分隔多个
    owner_list?: string, //过滤责任人，逗号分隔多个
    page_num?: number,
    page_size?: number,
    sort?: string, //排序字段名
    customer_level?: string, //线索等级
    customer_source?: string,
    industry?: string,
    sub_category?: string,
    activity_name?: string,
    target_region?: string //推广区域
    filtering?: [
        {
            field: string,
            operator: string,
            value: [
                string
            ]
        }
    ]
}
interface accountAnalysisParams {
    start_time: string,
    end_time: string,
    date_compare: boolean, //是否比对（仅比对不同的时间跨度
    contrast_end_time: string, //待对比的结束日期
    contrast_start_time: string, //待对比的开始日期
    date_type?: string, //date, week, month, quarter, year
    group_by: [], //需聚合的字段(时间维度除外)
    need_sum?: boolean, //是否返回合计
    // sum_only?: boolean, //是否只合计当前分页数据
    order?: string, //asc 升序; desc 降序
    org_level?: string, //过滤部门，逗号分隔多个
    owner_list?: string, //过滤责任人，逗号分隔多个
    page_num?: number,
    page_size?: number,
    sort?: string, //排序字段名
    customer_level?: string, //线索等级
    customer_source?: string,
    industry?: string,
    sub_category?: string,
    activity_name?: string,
    target_region?: string //推广区域,
    filtering?: [
        {
            field: string,
            operator: string,
            value: [
                string
            ]
        }
    ]
}

interface opptyAnalysisParams {
    contrast_end_time: string,
    contrast_start_time: string,
    date_compare: boolean,
    date_type: string,
    start_time: string,
    end_time: string,
    group_by: [],
    org_level: number,
    org_id?: [],
    page_num: number,
    page_size: number,
    need_sum?: boolean,
    order: string,
    sort: string,
    cooperation_channel?: [],
    cooperation_type?: [],
    business?: [],
    filtering?: [
        {
            field: string,
            operator: string,
            value: [
                string
            ]
        }
    ],

}

interface opptyStageAnalysisParams {
    contrast_end_time: string,
    contrast_start_time: string,
    date_compare: boolean,
    date_type: string,
    start_time: string,
    end_time: string,
    org_level: number,
    org_id?: [],
    stage: string
    page_num: number,
    page_size: number
}
interface followUpRecordAnalysisParams {
    contrast_start_time?: string,
    contrast_end_time?: string,
    start_time: string
    end_time: string,
    date_compare?: boolean,
    need_sum?: boolean,
    group_by: [],
    module?: [],
    order?: string,
    org_level?: number,
    org_id?: [],
    date_type?: string,
    filtering: [
        {
            field: string,
            operator: string,
            value: [
                string
            ]
        }
    ],
    page_num?: number,
    page_size?: number,
    sort?: string
}


export const getOptions = (params: any) => httpPostJson('/api/reports/getoptions', params); // 获取组织层级、市场活动
export const fetchLeadAnalysisData = (params: leadAnalysisParams) => httpPostJson('/api/reports/leads_report', params); // 线索分析
export const fetchAccountAnalysisData = (params: accountAnalysisParams) => httpPostJson('/api/reports/customer_report', params); // 客户分析
export const fetchOpptyAnalysisData = (params: opptyAnalysisParams) => httpPostJson('/api/reports/oppty_report', params); // 商机分析
export const fetchOpptyStageAnalysisData = (params: opptyStageAnalysisParams) => httpPostJson('/api/reports/oppty_stage_report', params); // 商机分析
export const fetchFollowUpRecordAnalysisData = (params: followUpRecordAnalysisParams) => httpPostJson('/api/reports/follow_up_report', params); // 跟进记录分析
export const exportAnalyticLeads = (params:any) => httpPostDataDownload('/api/reports/leads_export', params); // 线索分析数据导出
export const exportAnalyticCustomer = (params:any) => httpPostDataDownload('/api/reports/customer_export', params); // 客户分析数据导出
export const exportCustomerFollow = (params:any) => httpPostDataDownload('/api/reports/follow_up_export', params); // 客户跟进记录分析数据导出

export const exportAnalyticOppty = (params:any) => httpPostDataDownload('/api/reports/oppty_export', params); // 商机分析数据导出
export const exportBusinessFollow = (params:any) => httpPostDataDownload('/api/reports/oppty_stage_export', params); // 商机阶段数据导出
